import { createAction, props } from '@ngrx/store';
import { SchemaApiError } from './schema.errors';
import { SchemaProject } from 'src/app/admin/models/schema-project.model';
import { Schema } from 'src/app/admin/models/schema.model';
import { SchemaDefinition } from 'src/app/admin/models/schema-definition.model';

export const LoadSchemaDefinitions = createAction(
  '[Schema] Load Schema Definitions',
  props<{ projectId: number }>(),
);

export const SetSchemaDefinitions = createAction(
  '[Schema] Set Schema Definitions',
  props<{ definitions: SchemaDefinition[] }>(),
);

export const LoadSchemaDefinitionVersions = createAction(
  '[Schema] Load Schema Definition Versions',
  props<{ projectId: number; name: string }>(),
);

export const SetSchemaDefinitionVersions = createAction(
  '[Schema] Set Schema Definition Versions',
  props<{ definitionVersions: SchemaDefinition[] }>(),
);

export const LoadSchemaDefinition = createAction(
  '[Schema] Load Schema Definition',
  props<{ id: number }>(),
);

export const SetSchemaDefinition = createAction(
  '[Schema] Set Schema Definition',
  props<{ definition: SchemaDefinition }>(),
);

export const CreateSchemaDefinition = createAction(
  '[Schema] Create Schema Definition',
  props<{
    projectId: number;
    name: string;
    title: string;
    description: string;
    values: Record<string, unknown>;
  }>(),
);

export const GoToSchemaDefinition = createAction(
  '[Schema] Go To Schema Definition',
  props<{ definition: SchemaDefinition }>(),
);

export const DeleteSchemaDefinition = createAction(
  '[Schema] Delete Schema Definition',
  props<{ projectId: number; definitionId: number }>(),
);

export const LoadSchemaProjects = createAction('[Schema] Load Schema Projects');

export const SetSchemaProjects = createAction(
  '[Schema] Set Schema Projects',
  props<{ projects: SchemaProject[] }>(),
);

export const CreateSchemaProject = createAction(
  '[Schema] Create Schema Project',
  props<{ name: string }>(),
);

export const DeleteSchemaProject = createAction(
  '[Schema] Delete Schema Project',
  props<{ id: number }>(),
);

export const LoadCurrentSchemaProject = createAction(
  '[Schema] Load Current Schema Project',
  props<{ id: number }>(),
);

export const SetCurrentSchemaProject = createAction(
  '[Schema] Set Current Schema Project',
  props<{ project: SchemaProject }>(),
);

export const LoadCurrentSchemas = createAction(
  '[Schema] Load Current Schemas',
  props<{ projectId: number }>(),
);

export const SetCurrentSchemas = createAction(
  '[Schema] Set Current Schemas',
  props<{ schemas: Schema[] }>(),
);

export const LoadCurrentSchema = createAction(
  '[Schema] Load Current Schema',
  props<{ schemaId: number }>(),
);

export const SetCurrentSchema = createAction(
  '[Schema] Set Current Schema',
  props<{ schema: Schema }>(),
);

export const CreateSchema = createAction(
  '[Schema] Create Schema',
  props<{ projectId: number; description: string; values: Record<string, unknown> }>(),
);

export const SetSchemaError = createAction(
  '[Schema] Set Schema Error',
  props<{ error: SchemaApiError }>(),
);

export const RemoveSchemaError = createAction('[Schema] Remove Schema Error');

export const GoToCurrentSchemaProject = createAction(
  '[Schema] Go To Current Schema Project',
  props<{ projectId: number }>(),
);

export const LoadActiveSchema = createAction('[Schema] Load Active Schema');

export const SetActiveSchema = createAction(
  '[Schema] Set Active Schema',
  props<{ schema: Schema }>(),
);
